import { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";
import { IconCheckBrand } from "@/components/icons/BrandIcons";
import { UNLOCK_OUTCOME_ITEMS } from "@/constants/marketingHeroCopy";
import { ANALYTICS_EVENTS, trackEvent } from "@/lib/analytics";

/**
 * Shared "What you unlock" outcome checklist for pricing page and paywalls.
 */
export function PaywallUnlockValue({ className, compact = false, jobTitle, trackImpression = false }) {
  const impressedRef = useRef(false);
  const title =
    typeof jobTitle === "string" && jobTitle.trim()
      ? `What you unlock for ${jobTitle.trim()}`
      : "What you unlock";

  useEffect(() => {
    if (!trackImpression || impressedRef.current) return;
    impressedRef.current = true;
    trackEvent(ANALYTICS_EVENTS.PAYWALL_UNLOCK_LIST_IMPRESSION, {
      has_job_title: Boolean(jobTitle && String(jobTitle).trim()),
    });
  }, [trackImpression, jobTitle]);

  return (
    <div
      className={cn(compact ? "space-y-2.5" : "space-y-3", className)}
      data-testid="paywall-unlock-value"
    >
      <p
        className={cn(
          "font-heading font-semibold tracking-tight text-foreground",
          compact ? "text-sm sm:text-base" : "text-base sm:text-lg"
        )}
      >
        {title}
      </p>
      <ul className={cn(compact ? "space-y-2" : "space-y-2.5")}>
        {UNLOCK_OUTCOME_ITEMS.map((text) => (
          <li
            key={text}
            className={cn(
              "flex items-start gap-2.5 text-foreground",
              compact ? "text-sm" : "text-sm sm:text-base"
            )}
          >
            <IconCheckBrand
              className={cn(
                "shrink-0 text-primary",
                compact ? "mt-0.5 h-4 w-4" : "mt-0.5 h-5 w-5"
              )}
            />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
